<div class="flex justify-between items-center p-2 border-b">
    <h2 mat-dialog-title class="text-xl font-bold">Configuración de campos de usuario</h2>
    <button mat-icon-button mat-dialog-close matTooltip="Cerrar">
        <mat-icon svgIcon="heroicons_outline:x-circle"></mat-icon>
    </button>
</div>

<mat-dialog-content class="p-0 max-h-[75vh] flex flex-col overflow-auto">
    <mat-tab-group [(selectedIndex)]="selectedEntityIndex" class="border-b sticky top-0 z-20 bg-white">
        <mat-tab *ngFor="let entity of entities; let entityIndex = index" [label]="getEntityLabel(entity)">

            <form [formGroup]="formConfigs[entity]" class="p-4">

                <div class="mb-6 border-b pb-4 w-full">
                    <app-toggle-option
                        title="Habilitar Configuración"
                        icon="settings"
                        iconColor="green"
                        formControlName="statusId"
                        containerClass="w-full"
                        description="¿Desea habilitar campos de usuario?"
                    >
                    </app-toggle-option>
                </div>

                <ng-container formArrayName="fields">
                    <div *ngIf="getFieldControls(entity).length > 0; else noFields"
                        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">

                        <div *ngFor="let fieldGroup of getFieldControls(entity); let i = index" [formGroupName]="i"
                            class="flex flex-col border rounded p-4 shadow-md">

                            <mat-form-field class="w-full mb-3" appearance="outline">
                                <mat-label>Nombre del Campo</mat-label>
                                <input matInput formControlName="name" placeholder="Ej. fieldKey" />
                                <mat-hint>Nombre de la propiedad en el modelo</mat-hint>
                            </mat-form-field>
                            <br>

                            <mat-form-field appearance="outline" class="w-full mb-4">
                                <mat-label>Tipo de Dato</mat-label>
                                <mat-select formControlName="dataType">
                                    <mat-option *ngFor="let type of dataTypeList" [value]="type.value">
                                        {{ type.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <div formGroupName="labels" class="space-y-3 mb-4">
                                <h4 class="text-sm font-semibold text-gray-700 border-b pb-1">Etiquetas</h4>

                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>Master</mat-label>
                                    <input matInput formControlName="master" />
                                </mat-form-field>
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>Reporte</mat-label>
                                    <input matInput formControlName="report" />
                                </mat-form-field>
                                <mat-form-field class="w-full" appearance="outline">
                                    <mat-label>Móvil</mat-label>
                                    <input matInput formControlName="mobile" />
                                </mat-form-field>
                            </div>                            

                            <div class="space-y-3">
                                <app-toggle-option title="Requerido" icon="error_outline" iconColor="red"
                                    formControlName="required">
                                </app-toggle-option>

                                <br>

                                <app-toggle-option title="Visible" icon="visibility" iconColor="blue"
                                    formControlName="statusId">
                                </app-toggle-option>
                            </div>

                        </div>
                    </div>

                    <ng-template #noFields>
                        <p class="text-center text-gray-500 py-4">No hay campos configurados para esta entidad.</p>
                    </ng-template>
                </ng-container>
            </form>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>

<div class="sticky bottom-0 bg-white border-t p-4 flex justify-between items-center">
    <button mat-flat-button color="primary" class="w-48" (click)="addNewField(entities[selectedEntityIndex])"
        [disabled]="getFieldControls(entities[selectedEntityIndex]).length >= 10">
        <mat-icon>add</mat-icon>
        Agregar Campo
    </button>

    <button mat-flat-button color="accent" class="w-48" (click)="saveConfig(entities[selectedEntityIndex])"
        [disabled]="!formConfigs[entities[selectedEntityIndex]]?.valid">
        Actualizar Configuración
    </button>
</div>